
let stateA = [{
  UserInfo: {} ,User_verified: {}
}]

let user = {}

export const UserInfoReducer = (state = stateA, action) => {
  switch (action.type) {
    case 'USER_INFO':
      user = action.payload.userinfo
      return {
        ...state,
        userInfo: action.payload.userinfo
      }
    case 'USER_VERIFIED':
      return {
        ...state,
        UserInfo: user,
        User_verified:  action.payload.user_verified
      }
    default:
      return state
  }
}
